/** @jsx jsx */
import React from 'react'
import { Box, Button, Card, Flex, Heading, jsx, Text } from 'theme-ui'

import Img from 'gatsby-image'

import { Fragment, useState } from 'react'
import ScrollContainer from 'react-indiana-drag-scroll'

const SizeGuide = ({ sizeGuides, ...props }) => {
  const [chosenGuide, setChosenGuide] = useState(0)

  if (!sizeGuides || sizeGuides.length < 1) {
    return <Fragment />
  }

  return (
    <Box sx={{ height: '100%', lineHeight: 0 }}>
      <Box
        sx={{
          maxHeight: 'auto',
          position: 'relative',
          zIndex: 10,
          textAlign: 'center',
        }}
      >
        <Text
          sx={{
            position: 'absolute',
            top: 10,
            left: 10,
            p: '0',
            zIndex: 30,
            mb: 20,
            fontWeight: 'bold',
          }}
        >
          {sizeGuides[chosenGuide].title}
        </Text>
        {sizeGuides &&
        sizeGuides[chosenGuide] &&
        sizeGuides[chosenGuide].guideImage ? (
          sizeGuides[chosenGuide].guideImage.file &&
          sizeGuides[chosenGuide].guideImage.file.contentType.includes(
            'video'
          ) ? (
            <video
              autoPlay
              muted
              loop
              playsInline
              sx={{
                width: ['100%', '100%'],
              }}
              preload="auto"
            >
              <source
                src={sizeGuides[chosenGuide].guideImage.file.url}
                type="video/mp4"
              />
            </video>
          ) : (
            <ScrollContainer
              veritcalScroll={false}
              hideScrollbars={false}
              sx={{
                overflow: 'auto',
                width: '100%',
                paddingBottom: '10px',
                '::-webkit-scrollbar': {
                  height: '3px',
                },
                '::-webkit-scrollbar-track': {
                  marginX: ['1.5em', '1.5em'],
                  background: '#f1efea',
                },
                '::-webkit-scrollbar-thumb': {
                  background: 'black',
                },
                '::-webkit-scrollbar-thumb:hover': {
                  background: 'gray',
                },
              }}
            >
              <img
                style={{ height: '60vh', width: 'auto' }}
                imgStyle={{ height: '60vh', width: 'auto' }}
                src={sizeGuides[chosenGuide].guideImage.file.url}
                alt="sizeGuide"
              />
            </ScrollContainer>
          )
        ) : (
          'Sorry no guide image added.'
        )}
      </Box>
      {sizeGuides.length > 1 && (
        <Flex
          sx={{ width: '100%', p: ['10px'], mt: 20, justifyContent: 'center' }}
        >
          {sizeGuides.map((i, k) => {
            return (
              <>
                {' '}
                <Text
                  key={k}
                  sx={{
                    color: 'text',
                    cursor: 'pointer',
                    marginX: '10px',
                    fontWeight: k === chosenGuide ? 'bold' : '',
                  }}
                  onClick={() => setChosenGuide(k)}
                >
                  {i.title}
                </Text>
                {k !== sizeGuides.length - 1 && (
                  <Box
                    sx={{
                      display: 'inline-block',
                      mt: '2px',
                      mx: '5px',
                      fontSize: 22,
                    }}
                  >
                    {' '}
                    |{' '}
                  </Box>
                )}
              </>
            )
          })}
        </Flex>
      )}
    </Box>
  )
}

export default SizeGuide
